import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import Select from 'component/utils/Select'
import { connect } from 'react-redux'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class CompanySelect extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    excludeInactive: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      companies: [],
      error: null,
      loading: false,
    }
  }

  componentDidMount() {
    const { user, excludeInactive } = this.props

    this.setState({ loading: true })

    /* istanbul ignore else */
    if (user) {
      const endpoint = excludeInactive ? `${API_URL.BRANCHES}?excludeInactive=true` : API_URL.BRANCHES
      return new Api(user.dsToken)
        .post(endpoint)
        .then((response) => this.onFetchSuccess(response.data))
        .catch((error) => this.onFetchError(error))
    }
  }

  onFetchSuccess(companies) {
    this.setState({ companies, loading: false, error: null })
  }

  onFetchError(error) {
    this.setState({ error, loading: false, companies: [] })
  }

  renderOptions(company, index) {
    return (
      <option key={index} value={company.id}>
        {company.id} - {company.name}
      </option>
    )
  }

  render() {
    const { name, value, onChange } = this.props
    const t = this.props.translate
    const { companies, loading } = this.state

    const label = loading ? t('ruptures.loading') : t('ruptures.idBranch')

    return (
      <Select
        id='idRegion'
        name={name}
        label={label}
        value={value}
        onChange={(event) => onChange(event)}
      >
        <option value='' />

        {companies.map(this.renderOptions)}
      </Select>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({ auth }) =>
  /* istanbul ignore next */
  ({
    user: auth.user,
  })

/*
 * Connects component to I18next
 */
/* istanbul ignore next */
const CompanySelectTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(CompanySelect)

/*
 * Exports component connected to redux
 */
/* istanbul ignore next */
export default connect(mapStateToProps)(CompanySelectTranslated)

/*
 * Exports component only
 */
/* istanbul ignore next */
export { CompanySelect }
